import { BehaviorSubject } from 'rxjs';
import { DrillData } from '@app/models/data-collection.model';
import { DataCollectionQueryState, PaginatedResponse } from '@app/backend/data-collection';

export class DataCollectionStore {
    readonly response$ = new BehaviorSubject<PaginatedResponse<DrillData>>(null);
    readonly loading$ = new BehaviorSubject<boolean>(false);
    readonly query$ = new BehaviorSubject<DataCollectionQueryState>({
        search: '', completionStatus: '', pageIndex: 0, pageSize: 30
    });
}
